export const createFilterOptions = (values) => {
    return values.map(createFilterOption);
};
export const createFilterOption = (value) => {
    return { value, selected: false };
};
